/* eslint-disable consistent-return */
import React, { Component } from "react"
import PropTypes from "prop-types"

// D3
import { select } from "d3-selection"
import { axisBottom, axisLeft, axisRight, axisTop } from "d3-axis"

class Axis extends Component {
  componentDidMount() {
    this.drawAxis()
  }

  componentDidUpdate() {
    this.drawAxis()
  }

  drawAxis() {
    const {
      adjustTextLength,
      orientation,
      scale,
      textClass,
      tickSize,
      tickPadding,
      ticks,
      tickValues,
      tickColorScale
    } = this.props

    const axes = {
      bottom: axisBottom,
      left: axisLeft,
      right: axisRight,
      top: axisTop
    }

    const axis = axes[orientation]()
      .scale(scale)
      .tickSize(tickSize)
      .tickPadding(tickPadding)
      .ticks(ticks)
      .tickValues(tickValues)

    select(this.axisEl).call(axis)

    if (scale.bandwidth && adjustTextLength) {
      select(this.axisEl)
        .selectAll("text")
        .attr("class", textClass)
        .attr("id", (_d, i) => {
          if (i === 0) return `${textClass}-first`
          if (i === scale.domain().length - 1) return `${textClass}-last`
        })
    }

    if (tickColorScale) {
      select(this.axisEl)
        .selectAll(".tick")
        .selectAll("text")
        .attr("fill", d => tickColorScale(d))
    }
  }

  render() {
    const { classes, translate } = this.props

    return (
      <g
        className={classes}
        ref={el => (this.axisEl = el)}
        transform={translate}
      />
    )
  }
}

export default Axis

Axis.propTypes = {
  adjustTextLength: PropTypes.bool,
  classes: PropTypes.string,
  orientation: PropTypes.oneOf(["top", "right", "bottom", "left"]),
  scale: PropTypes.func.isRequired,
  textClass: PropTypes.string,
  tickSize: PropTypes.arrayOf(PropTypes.number),
  tickPadding: PropTypes.arrayOf(PropTypes.number),
  ticks: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.number,
    PropTypes.func
  ]),
  tickValues: PropTypes.arrayOf(PropTypes.number),
  tickColorScale: PropTypes.func,
  translate: PropTypes.string
}

Axis.defaultProps = {
  adjustTextLength: false,
  classes: "axis",
  orientation: "bottom",
  textClass: "scaled-text",
  tickSize: [1],
  tickPadding: [7],
  ticks: null,
  tickValues: undefined,
  tickColorScale: null,
  translate: "translate(0, 0)"
}
